const authGuard = (meta) => meta.dispatch(authGuardAction(meta));

const authGuardAction = (to) => (_dispatch, getState) => {

	const state = getState()

	const checkPath = [
		"/login",
		"/forget-password",
		"/forget-password/success",
		"/reset-password",
		"/reset-password/success",
		"/sign-up",
		"/reset-2fa"
	];

	if (!state.auth.loggedIn && !(checkPath.includes(to?.location?.currentPath)) ) {
		const currentPath = to?.location?.currentPath;
		if (currentPath && currentPath !== '/') {
			return `/login?returnUrl=${encodeURIComponent(currentPath)}`;
		}
		return '/login'
	}

	return null
}

export { authGuard };
